import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav aria-label="面包屑导航" className="max-w-7xl mx-auto px-4 md:px-6 py-4">
      <ol className="flex items-center flex-wrap gap-1 text-sm">
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1">
            {index > 0 && (
              <span className="text-foreground-400 mx-1">
                <i className="ri-arrow-right-s-line text-xs w-3 h-3 flex items-center justify-center"></i>
              </span>
            )}
            {item.path && index < items.length - 1 ? (
              <Link
                to={item.path}
                className="text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
              >
                {item.label}
              </Link>
            ) : (
              <span
                className={
                  index === items.length - 1
                    ? 'text-foreground-900 font-medium'
                    : 'text-foreground-500'
                }
              >
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}